import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldNumberInput } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const DecimalFieldToBlock: FieldToBlock<
  'decimal',
  WorkflowStepFormFieldNumberInput
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'number-input',
  componentProps: {
    inputMode: 'decimal',
    size: 'sm',
  },
});

type DecimalFieldValueProps = FieldValueProps<'decimal'>;

export const DecimalFieldValue: FC<DecimalFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
